import type { User } from '@/types/domains/UserType';
import { USER_CONSTANTS } from '@/consts/UserConst';

/**
 * ゴールド・プラチナ・その他の「特別ランク」会員か。
 *
 * このランクの会員は通常価格販売のみのため、**サイト内のどこへ遷移しても
 * `/special-message` に戻される**（`plugins/102-restrict-navigation-for-special-rank.ts`）。
 * 買い物ができない前提なので、キャンペーンの導線も出さない。
 */
export const isSpecialRank = (user: Pick<User, 'userRankId'> | null): boolean => {
  if (!user) {
    return false;
  }
  return Object.keys(USER_CONSTANTS.SPECIAL_RANKS).includes(user.userRankId.toString());
};
